const ENTITIES = {
  students: 'Estudiante',
  tutors: 'Padre/Tutor',
  teachers: 'Profesor',
};

export default ENTITIES;
